import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, Drawer, Typography, Stack } from '@mui/material';
import useResponsive from '../../../hooks/useResponsive';
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
import navConfig from './config';

const NAV_WIDTH = 280;

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 2.5, display: 'flex', alignItems: 'center', gap: 1.5, borderBottom: `1px solid ${alpha('#FFF', 0.08)}`, mb: 1 }}>
        <Logo disabledLink white sx={{ width: 40, height: 40 }} />
        <Stack sx={{ minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap sx={{ color: '#FFF', fontWeight: 700, lineHeight: 1.2 }}>
            B&B Target Center
          </Typography>
          <Typography variant="caption" noWrap sx={{ color: alpha('#FFF', 0.45), fontSize: 11 }}>
            Admin Dashboard
          </Typography>
        </Stack>
      </Box>

      <Box sx={{ mt: 1 }}>
        <NavSection data={navConfig} />
      </Box>

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ px: 3, pb: 3, pt: 2 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: alpha('#FFF', 0.06),
            textAlign: 'center',
          }}
        >
          <Typography variant="caption" sx={{ color: alpha('#FFF', 0.5), display: 'block' }}>
            BBTC Dashboard v2.0
          </Typography>
        </Box>
      </Box>
    </Scrollbar>
  );

  const sidebarStyles = {
    width: NAV_WIDTH,
    // Gris azulado neutro (el gray-900 que usan casi todos los dashboards).
    // El #1C2536 anterior tiraba a azul y peleaba con el rojo de la marca.
    bgcolor: '#111827',
    borderRight: '1px solid rgba(255,255,255,0.06)',
  };

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{ sx: sidebarStyles }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: sidebarStyles }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
